<template>
    <div class="block-view">
 
       <div class="mt-3 pt-3">
          <nav class="breadcrumb-wrapper" aria-label="breadcrumb">
             <ol class="breadcrumb">
                <li class="breadcrumb-item" style="color:#435666;" aria-current="page">Sales Pipeline</li>
                <li class="breadcrumb-item clickable-row" aria-current="page" @click="goToMainPage">Proposals</li>
                <li class="breadcrumb-item d-flex align-items-center" aria-current="page">
                   <span v-if="!isEditingTitle" @click="startEditingTitle" class="editable-title-span" style="cursor: pointer;" title="Click to edit title">
                      {{ title || 'Vertex Cyber Security Proposal' }}
                      <i class="fa-solid fa-pen-to-square ms-2 edit-icon-btn" style="font-size: 12px; cursor: pointer; color: #435666;"></i>
                   </span>
                   <input v-else
                      ref="titleInput"
                      type="text"
                      v-model="editableTitle"
                      @blur="saveTitle"
                      @keyup.enter="saveTitle"
                      @keyup.esc="cancelEditingTitle"
                      class="form-control form-control-sm breadcrumb-title-input"
                      style="display: inline-block; width: auto; min-width: 300px; max-width: 500px; font-weight: bold; margin-left: 5px; height: 28px; padding: 2px 8px;"
                   />
                </li>
             </ol>
          </nav>
       </div>
 
       <div>
          <ProposalView :id="id" ref="proposalViewRef"/>
       </div>
 
    </div>
 
    <!-- <div>
  
        <div class="text-center">
           <nav class="breadcrumb-wrapper" aria-label="breadcrumb">
              <ol class="breadcrumb">
                 <li class="breadcrumb-item" aria-current="page">Page Not Found</li>
              </ol>
           </nav>BlockDetailedView
        </div>
  
     </div> -->
 </template>
 
 <script>
 import ProposalView from "@/components/Proposals/ProposalView.vue"
 
 export default ({
 
    components: {
        ProposalView
    },
 
    props: {
       id: {
          type: String,
       },
       block_type: {
          type: String,
       }
    },
 
    data() {
       return {
          title: "",
          organisationId: 0,
          isEditingTitle: false,
          editableTitle: "",
       }
    },
 
    computed: {
       item() {
          return this.id
       },
 
       currentOrg() {
          return this.$store.state.auth.currentOrganisation.id
       }
 
    },
 
    watch: {
       item() {
          this.init()
       },
       title(newVal) {
          if (newVal) {
             document.title = newVal;
          }
       }
    },
 
    created() {
 
    },
 
    methods: {
       goToMainPage() {
          this.$router.push({ name: 'proposals_v2' })
       },
       startEditingTitle() {
          this.editableTitle = this.title;
          this.isEditingTitle = true;
          this.$nextTick(() => {
             if (this.$refs.titleInput) {
                this.$refs.titleInput.focus();
             }
          });
       },
       cancelEditingTitle() {
          this.isEditingTitle = false;
       },
       async saveTitle() {
          const sanitized = this.editableTitle.replace(/<[^>]*>?/gm, '').replace(/[\r\n\t]/g, ' ').trim();
          if (!sanitized) {
             this.$toast.error("Proposal title cannot be empty or contain only HTML tags");
             this.cancelEditingTitle();
             return;
          }
          this.isEditingTitle = false;
          if (sanitized === this.title) return;

          this.title = sanitized;
          this.editableTitle = sanitized;

          // Update child components
          if (this.$refs.proposalViewRef) {
             this.$refs.proposalViewRef.proposal_title = sanitized;
             if (this.$refs.proposalViewRef.$refs.proposalDetailsFormRef) {
                this.$refs.proposalViewRef.$refs.proposalDetailsFormRef.proposal.proposal_title = sanitized;
                this.$refs.proposalViewRef.$refs.proposalDetailsFormRef.currentProposalName = sanitized;
             }
          }

          try {
             const response = await this.$axios.put(`/proposals/${this.id}/title`, { proposal_title: sanitized });
             if (response.data && response.data.sanitized_title) {
                this.title = response.data.sanitized_title;
                this.editableTitle = response.data.sanitized_title;
             }
             this.$toast.success("Proposal title updated successfully");
          } catch (error) {
             console.error(error);
             this.$toast.error("Failed to update proposal title");
          }
       }
    },
 })
 </script>
 
 <style scoped>
 .clickable-row:hover {
    text-decoration: underline;
 }
 </style>